(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[782],{

/***/ 313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5675);



var Image = function(param) {
    var _src = param.src, src = _src === void 0 ? '' : _src, width = param.width, height = param.height, className = param.className, _alt = param.alt, alt = _alt === void 0 ? '' : _alt, layout = param.layout, loading = param.loading, quality = param.quality, priority = param.priority, title = param.title, onClick = param.onClick, objectFit = param.objectFit;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_2__["default"], {
        src: src,
        width: width,
        height: height,
        className: className,
        alt: alt,
        layout: layout,
        loading: loading,
        quality: quality,
        priority: priority,
        title: title,
        onClick: onClick,
        objectFit: objectFit
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(Image));


/***/ }),

/***/ 2304:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7379);
/* harmony import */ var styles_animations__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3167);
/* harmony import */ var images_global_loader_png__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9090);
/* harmony import */ var images_global_loader_png__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(images_global_loader_png__WEBPACK_IMPORTED_MODULE_3__);





function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      width: 100vw;\n      transform: translate(-50%, -50%);\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n\n  .loader {\n    border: none;\n    background-image: url(",
        ");\n    background-repeat: no-repeat;\n    background-size: 100%;\n    border-radius: 50%;\n    margin: 1rem auto;\n    width: 50px;\n    height: 50px;\n    animation: ",
        " 0.8s infinite linear;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var Loader = function(param) {
    var abCenter = param.abCenter;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledLoader, {
        abCenter: abCenter,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            role: "presentation",
            className: "loader"
        })
    });
};
var StyledLoader = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-b3e25d50-0"
})(_templateObject1(), function(props) {
    return props.abCenter && (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject());
}, (images_global_loader_png__WEBPACK_IMPORTED_MODULE_3___default()), styles_animations__WEBPACK_IMPORTED_MODULE_2__/* .rotate */ .U1);
/* harmony default export */ __webpack_exports__["Z"] = (Loader);


/***/ }),

/***/ 8761:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "jR": function() { return /* reexport */ AccountInputCss; },
  "zx": function() { return /* reexport */ common_Button; },
  "$_": function() { return /* reexport */ common_Footer; },
  "PJ": function() { return /* reexport */ Icons; },
  "Ee": function() { return /* reexport */ Image/* default */.Z; },
  "II": function() { return /* reexport */ Input; },
  "rU": function() { return /* reexport */ Link/* default */.Z; },
  "aN": function() { return /* reexport */ Loader/* default */.Z; },
  "Vm": function() { return /* reexport */ common_Messages; },
  "HJ": function() { return /* reexport */ common_SEO; }
});

// UNUSED EXPORTS: Header, Layout

// EXTERNAL MODULE: ./components/common/Layout/index.tsx
var Layout = __webpack_require__(4367);
// EXTERNAL MODULE: ./components/common/Header/index.tsx
var Header = __webpack_require__(2115);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(7379);
// EXTERNAL MODULE: ./styles/colors.ts
var colors = __webpack_require__(2317);
// EXTERNAL MODULE: ./styles/helper.ts + 1 modules
var helper = __webpack_require__(9900);
// EXTERNAL MODULE: ./lib/hooks/index.ts + 6 modules
var hooks = __webpack_require__(8113);
// EXTERNAL MODULE: ./constants/index.ts
var constants = __webpack_require__(1407);
// EXTERNAL MODULE: ./components/common/Link/index.tsx
var Link = __webpack_require__(6754);
;// CONCATENATED MODULE: ./components/common/Footer/index.tsx








function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      margin-bottom: 75px;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex: 1;\n  align-items: flex-end;\n  text-align: center;\n  width: 100%;\n  height: 220px;\n  color: ",
        ";\n  font-size: 10px;\n  line-height: 1.8em;\n  opacity: 50%;\n  .inner {\n    max-width: 350px;\n    margin: 0 auto;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    align-self: flex-end;\n    ",
        "\n  }\n  hr {\n    width: 100%;\n    max-width: 300px;\n    opacity: 50%;\n  }\n  a {\n    display: inline-block;\n    text-decoration: none;\n    span {\n      border-bottom: 0.5px solid;\n    }\n  }\n  .helpLink {\n    font-size: 14px;\n    color: ",
        ";\n    font-family: 'Graphik', serif;\n    font-weight: 600;\n    text-decoration: none;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var Footer = function() {
    var language_strings_en_US = (0,hooks/* useLanguageStrings */.F2)().language_strings_en_US;
    var currentYear = new Date().getFullYear();
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFooter, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
            className: "inner",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                    className: "helpLink",
                    external: true,
                    href: constants/* LINKS.HELP_LINK */.BA.HELP_LINK,
                    target: constants/* LINKS.target */.BA.target,
                    children: language_strings_en_US === null || language_strings_en_US === void 0 ? void 0 : language_strings_en_US.auth_selectProviderHelpText
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                    className: "helpLink"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "legal",
                    children: [
                        "\xa9 ",
                        currentYear,
                        " FOX. All Rights Reserved. Use of this website ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        " assumes acceptance of the",
                        ' ',
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            external: true,
                            href: constants/* LINKS.TERMS_LINK */.BA.TERMS_LINK,
                            target: constants/* LINKS.target */.BA.target,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "Terms of Use."
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            "data-testid": "link",
                            external: true,
                            href: constants/* LINKS.DO_NOT_SELL_LINK */.BA.DO_NOT_SELL_LINK,
                            target: constants/* LINKS.target */.BA.target,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: language_strings_en_US === null || language_strings_en_US === void 0 ? void 0 : language_strings_en_US.ccpa_do_not_sell_label.toUpperCase()
                            })
                        })
                    ]
                })
            ]
        })
    }));
};
/* harmony default export */ var common_Footer = (Footer);
var StyledFooter = styled_components_browser_esm/* default.footer.withConfig */.ZP.footer.withConfig({
    componentId: "sc-995d4449-0"
})(_templateObject1(), colors/* default.white */.Z.white, helper/* respondTo.bp_767 */.s.bp_767(_templateObject()), colors/* default.white */.Z.white);

// EXTERNAL MODULE: ./components/common/Image/index.tsx
var Image = __webpack_require__(313);
;// CONCATENATED MODULE: ./components/common/Input/index.ts


function Input_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Input_templateObject() {
    var data = Input_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 50px;\n  padding-left: 1rem;\n  border-radius: 6px;\n  outline: none;\n  background: ",
        ";\n  border: none;\n  color: inherit;\n  font-size: 17px;\n  font-weight: 600;\n  text-align: center;\n  &:focus:not(.error) {\n    outline: 0;\n    color: ",
        ";\n    background: ",
        ";\n  }\n"
    ]);
    Input_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Input_templateObject1() {
    var data = Input_taggedTemplateLiteral([
        "\n  max-width: 340px;\n  font-weight: normal;\n  text-align: left;\n  color: ",
        ";\n  &:focus,\n  :active {\n    color: ",
        ";\n    &::placeholder {\n      color: ",
        ";\n      opacity: 0.5;\n    }\n  }\n  &::placeholder {\n    color: ",
        ";\n    opacity: 0.5;\n  }\n"
    ]);
    Input_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var Input = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-eb801535-0"
})(Input_templateObject(), colors/* default.white10 */.Z.white10, colors/* default.white */.Z.white, colors/* default.white10 */.Z.white10);
var AccountInputCss = (0,styled_components_browser_esm/* css */.iv)(Input_templateObject1(), colors/* default.white */.Z.white, colors/* default.white */.Z.white, colors/* default.white */.Z.white, colors/* default.white */.Z.white);


;// CONCATENATED MODULE: ./components/common/Button/index.ts


function Button_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Button_templateObject() {
    var data = Button_taggedTemplateLiteral([
        "\n  font: inherit;\n  background: ",
        ";\n  color: ",
        ";\n  position: relative;\n  display: flex;\n  width: 100%;\n  max-width: 340px;\n  height: 44px;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  border: none;\n  border: 1px solid ",
        ";\n  margin: 20px auto;\n  border-radius: 22px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n  letter-spacing: -0.25px;\n  outline: 0;\n  transition: ease all 200ms;\n  &:hover {\n    background: ",
        ";\n    color: ",
        ";\n    border: ",
        ";\n    transition: ease all 200ms;\n  }\n  &:disabled {\n    background: ",
        ";\n    cursor: initial;\n    opacity: 0.5;\n    color: ",
        ";\n  }\n"
    ]);
    Button_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var Button = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-7d1b9628-0"
})(Button_templateObject(), colors/* default.endeavour */.Z.endeavour, colors/* default.white */.Z.white, colors/* default.endeavour */.Z.endeavour, colors/* default.button.background */.Z.button.background, colors/* default.button.text */.Z.button.text, colors/* default.button.background */.Z.button.background, colors/* default.button.background */.Z.button.background, colors/* default.button.disabled */.Z.button.disabled);
/* harmony default export */ var common_Button = (Button);

// EXTERNAL MODULE: ./components/common/Loader/index.tsx
var Loader = __webpack_require__(2304);
// EXTERNAL MODULE: ./node_modules/react-cookie/es6/useCookies.js + 1 modules
var useCookies = __webpack_require__(708);
// EXTERNAL MODULE: ./lib/hooks/useFlowManager.ts
var useFlowManager = __webpack_require__(9697);
// EXTERNAL MODULE: ./components/common/Icons/CheckMark.tsx
var CheckMark = __webpack_require__(2950);
// EXTERNAL MODULE: ./context/GlobalContextProvider.tsx
var GlobalContextProvider = __webpack_require__(1387);
;// CONCATENATED MODULE: ./components/common/Messages/index.tsx










function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function Messages_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function Messages_templateObject() {
    var data = Messages_taggedTemplateLiteral([
        "\n    font-size: 20px;\n    letter-spacing: -0.3px;\n  "
    ]);
    Messages_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Messages_templateObject1() {
    var data = Messages_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-size: 15px;\n  font-family: Graphik, serif;\n  font-weight: normal;\n  letter-spacing: -0.27px;\n  line-height: 20px;\n  ",
        "\n"
    ]);
    Messages_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = Messages_taggedTemplateLiteral([
        "\n    font-size: 40px;\n    letter-spacing: -0.5px;\n    line-height: 45px;\n    margin: 25px 0 50px;\n\t"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = Messages_taggedTemplateLiteral([
        "\n  margin-bottom: 50px;\n  font-family: Graphik, serif;\n  font-size: 19px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: 0;\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
var string = {
    profileSignedIn: "You're signed in!",
    profileSignedUp: 'Your profile has been created!',
    mainTitle: 'Select TV Provider'
};
var Messages = function() {
    var ref, ref1;
    var ref2 = _slicedToArray((0,useCookies/* default */.Z)([
        constants/* ACCOUNT_COOKIE_NAME_FOX */.EO,
        constants/* COOKIE_CODE_INFO */.r5
    ]), 1), cookies = ref2[0];
    var ref3 = (0,useFlowManager/* default */.Z)(), isMVPD = ref3.isMVPD, isNew = ref3.isNew;
    var ref4 = (0,react.useContext)(GlobalContextProvider/* AppContext */.I), _state = ref4.state, _isRegister = _state.isRegister, isRegister = _isRegister.value;
    var mainTitle = /*#__PURE__*/ (0,jsx_runtime.jsx)(H1, {
        children: string.mainTitle
    });
    if (((ref = cookies[constants/* ACCOUNT_COOKIE_NAME_FOX */.EO]) === null || ref === void 0 ? void 0 : ref.accountType) !== constants/* ANONYMOUS */.o2 || isNew || isRegister) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckMark/* default */.Z, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Message, {
                    children: isRegister ? string.profileSignedUp : string.profileSignedIn
                }),
                mainTitle
            ]
        }));
    }
    if (isMVPD || ((ref1 = cookies[constants/* COOKIE_CODE_INFO */.r5]) === null || ref1 === void 0 ? void 0 : ref1.isAnonymous)) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: mainTitle
        }));
    }
    return null;
};
/* harmony default export */ var common_Messages = (Messages);
var Message = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-5c381f60-0"
})(Messages_templateObject1(), colors/* default.white */.Z.white, helper/* respondTo.bp_767 */.s.bp_767(Messages_templateObject()));
var H1 = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-5c381f60-1"
})(_templateObject3(), helper/* respondTo.bp_767 */.s.bp_767(_templateObject2()));

// EXTERNAL MODULE: ./components/common/Icons/index.ts + 7 modules
var Icons = __webpack_require__(8736);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./lib/utils/configs.ts
var configs = __webpack_require__(2670);
;// CONCATENATED MODULE: ./components/common/SEO/index.tsx




var SEO = function(param) {
    var title = param.title;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
        title: title,
        titleTemplate: "Second Screen Activation | %s",
        openGraph: {
            type: 'website',
            locale: 'en_IE',
            url: configs/* config.registrationUrl */.vc.registrationUrl,
            site_name: 'Second Screen Activation'
        }
    }));
};
/* harmony default export */ var common_SEO = (SEO);

;// CONCATENATED MODULE: ./components/common/index.tsx














/***/ }),

/***/ 3860:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _home_runner_work_go_foxsports_com_go_foxsports_com_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _home_runner_work_go_foxsports_com_go_foxsports_com_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_go_foxsports_com_go_foxsports_com_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var context_state_reducer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2807);
/* harmony import */ var context_GlobalContextProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1387);
/* harmony import */ var constants_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1407);
/* harmony import */ var _helper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9981);
/* harmony import */ var _configs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2670);
/* harmony import */ var _hooks_useFlowManager__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9697);








function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var useSetUserLoggedInOrRegistered = function(param) {
    var profile = param.profile, existingEmail = param.existingEmail;
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), shouldRedirectToMvpd1 = ref4[0], setShouldRedirectToMvpd = ref4[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), shouldRedirectToSuccess2 = ref1[0], setShouldRedirectToSuccess = ref1[1];
    var ref2 = (0,_hooks_useFlowManager__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(), accessToken = ref2.accessToken, isMVPD = ref2.isMVPD, code = ref2.code, cookies = ref2.cookies;
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(context_GlobalContextProvider__WEBPACK_IMPORTED_MODULE_3__/* .AppContext */ .I), dispatch = ref3.dispatch, _state = ref3.state, _isRegister = _state.isRegister, isRegister = _isRegister.value;
    var handleLoggedInOrRegistered = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(_asyncToGenerator(_home_runner_work_go_foxsports_com_go_foxsports_com_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var skipMVPD, updatedProfile, ref5, res, shouldRedirectToSuccess, res1, shouldRedirectToMvpd, shouldRedirectToSuccess1;
        return _home_runner_work_go_foxsports_com_go_foxsports_com_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    skipMVPD = function() {
                        var ref;
                        if (window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.href) {
                            return (window === null || window === void 0 ? void 0 : window.location.href.indexOf('skip')) !== -1;
                        }
                        return false;
                    };
                    _ctx.next = 3;
                    return (0,_helper__WEBPACK_IMPORTED_MODULE_5__.setConfigToProfile)(profile, {
                        appName: _configs__WEBPACK_IMPORTED_MODULE_6__/* .profileConfig.appName */ .Vc.appName,
                        appVersion: _configs__WEBPACK_IMPORTED_MODULE_6__/* .profileConfig.appVersion */ .Vc.appVersion,
                        accessToken: accessToken
                    });
                case 3:
                    updatedProfile = _ctx.sent;
                    _ctx.prev = 4;
                    if (!code) {
                        _ctx.next = 28;
                        break;
                    }
                    ;
                    if (!(existingEmail || isRegister === false || ((ref5 = cookies[constants_index__WEBPACK_IMPORTED_MODULE_4__/* .COOKIE_CODE_INFO */ .r5]) === null || ref5 === void 0 ? void 0 : ref5.isRegister) === false)) {
                        _ctx.next = 18;
                        break;
                    }
                    _ctx.t0 = updatedProfile;
                    if (!_ctx.t0) {
                        _ctx.next = 13;
                        break;
                    }
                    _ctx.next = 12;
                    return updatedProfile.userLoggedInOrRegistered({
                        regCode: code,
                        isRegister: false
                    });
                case 12:
                    _ctx.t0 = _ctx.sent;
                case 13:
                    res = _ctx.t0;
                    shouldRedirectToSuccess = !!((res === null || res === void 0 ? void 0 : res.mvpdId) && (res === null || res === void 0 ? void 0 : res.apiKey));
                    setShouldRedirectToSuccess(shouldRedirectToSuccess);
                    _ctx.next = 28;
                    break;
                case 18:
                    _ctx.t1 = updatedProfile;
                    if (!_ctx.t1) {
                        _ctx.next = 23;
                        break;
                    }
                    _ctx.next = 22;
                    return updatedProfile.userLoggedInOrRegistered({
                        regCode: code,
                        isRegister: isRegister === true
                    });
                case 22:
                    _ctx.t1 = _ctx.sent;
                case 23:
                    res1 = _ctx.t1;
                    shouldRedirectToMvpd = isMVPD || !res1.mvpdId || !skipMVPD;
                    setShouldRedirectToMvpd(shouldRedirectToMvpd);
                    shouldRedirectToSuccess1 = !!((res1 === null || res1 === void 0 ? void 0 : res1.mvpdId) && (res1 === null || res1 === void 0 ? void 0 : res1.apiKey));
                    setShouldRedirectToSuccess(shouldRedirectToSuccess1);
                case 28:
                    _ctx.next = 33;
                    break;
                case 30:
                    _ctx.prev = 30;
                    _ctx.t2 = _ctx["catch"](4);
                    dispatch((0,context_state_reducer__WEBPACK_IMPORTED_MODULE_2__/* .setError */ .sT)(_ctx.t2));
                case 33:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                4,
                30
            ]
        ]);
    })), [
        accessToken,
        code,
        cookies,
        dispatch,
        existingEmail,
        isMVPD,
        isRegister,
        profile
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!(profile === null || profile === void 0 ? void 0 : profile.userLoggedInOrRegistered) || isMVPD) return;
        if (accessToken) {
            handleLoggedInOrRegistered();
        }
    }, [
        accessToken,
        handleLoggedInOrRegistered,
        isMVPD,
        profile === null || profile === void 0 ? void 0 : profile.userLoggedInOrRegistered
    ]);
    return {
        shouldRedirectToMvpd: shouldRedirectToMvpd1,
        shouldRedirectToSuccess: shouldRedirectToSuccess2
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useSetUserLoggedInOrRegistered);


/***/ }),

/***/ 3167:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U1": function() { return /* binding */ rotate; },
/* harmony export */   "jF": function() { return /* binding */ fadein; }
/* harmony export */ });
/* unused harmony export fadeinKeyFrames */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7379);

function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 100%;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  animation: ",
        " 100ms cubic-bezier(0.4, 0, 0.2, 1); ;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
var rotate = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .keyframes */ .F4)(_templateObject());
var fadeinKeyFrames = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .keyframes */ .F4)(_templateObject1());
var fadein = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(_templateObject2(), fadeinKeyFrames);


/***/ }),

/***/ 9090:
/***/ (function(module) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAtFBMVEUAAAD////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////oK74hAAAAPHRSTlMACgMHEh1zZhVLPTYk13hOQisYvY6GRjIh9aahmFZTLg64YSjv6dLFr6uck4mBbmpb++Xcs3w64M3KwV4uvJj/AAACYUlEQVRIx43V53LqMBAFYBX3ggu4YNywQzPEphuS93+vu0qGXLp1/lDmfCPtAgN6CNVlbzQf9/fRoNYo6gi2e4v9eDzu9/tfX7PZ7Gtg5W/qNI3m8/0VOJ/Pp5mMX9SJHS8WDOyvwOl0mvYT8qwveNGCgXkl25mIsRj49RzAdDo1F+5j31hGEYhRIt68K/cZMGfZff9YjQCMEvywhuZsmubOtO76I0gkCehJlCWA3S5FVwnjCkCKXqSGfmsGV/OuqqqKdfQyqtm27elvctKL46qC/hvRttvt+LJdLYZY6G2kLeQb/YR6yziWUUeq7XYyxYjFXy6Xg7wLKLvJZCIhCF4BUFFnJAAt27s+GAw82g2w+fHxsYYnBQAfcUQCELGRAbg8wAEwwchZrVY9xJXpcDhUkQpA5QMegBUqPM/L+EACYI8kACEf0IabjYl6n5+fCh8wNpvNBB0AUD6AAQwvgD/S4XAQOLsEQRoAImefBSW9Xs/hBJRSgmwANh+gP8AAIPMBDCGIShCF60YMwKMFQOe6UZ7nDDhSXcuUA+RCnlMGm7quOY7AAgSx6HXTyLhzAkURhN8WLZqm8buA4IK4/PYaWZaDjgFc11Xw5bQUQBG+HUAUAfx/uZaL4jt82wdB0F+UAsB39vL+YQjgZvUG9Nfr53/LRDQMEHd7NNYAktQhj+ssSwPEw96VFECSqmV+c3nXcRwQ4ZOzsZ8ASC3LLl0BE4JzRcyCIMtAhOTpXQ2L9S1V9X3b1rTjUdd/QCm8/PhL1r8HCnn3FRZ16P8CjQFDIKgjxC0DTbO1Y+CET9r/AD6sQgM7VcTdAAAAAElFTkSuQmCC"

/***/ })

}]);